import React, { useEffect } from "react";
import { Pagination, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSalesModel } from "../salesModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ISalesDetail } from "../salesTypes";
import { formatNum, momentFormat } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useSalesModel();
    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISalesDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'realCode',
            fixed: "left"
        }, {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '币种',
            width: 80,
            dataIndex: "currencyName"
        }, {
            title: '装货港',
            width: 200,
            dataIndex: "shipment",
            render: text => getTreeNodeName(text)
        }, {
            title: '卸货港',
            width: 180,
            dataIndex: 'discharge',
            render: text => getTreeNodeName(text)
        }, {
            title: '贸易条款',
            width: 100,
            dataIndex: 'clause',
            render: text => getTreeNodeName(text)
        }, {
            title: '商品类别',
            width: 100,
            dataIndex: 'typeNum',
        }, {
            title: '合同总金额',
            width: 100,
            dataIndex: 'contractAmount',
            render: (text: any, record: any) => `${getTreeNodeValue(record.currencyCode)}${formatNum(text)}`,
        }, {
            title: '收汇日期',
            width: 140,
            dataIndex: 'settlementTime',
            render: t => momentFormat(t, "YYYY-MM-DD")
        }, {
            title: '支付状态',
            width: 100,
            dataIndex: 'payStatus',
            render: text => getTreeNodeName(text)
        }, {
            title: '结汇日期',
            width: 140,
            dataIndex: 'payTime',
            render: t => momentFormat(t, "YYYY-MM-DD")
        }, {
            title: '贸易国别',
            width: 160,
            dataIndex: 'countryName',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '系统编号',
            width: 160,
            dataIndex: 'code',
            render: t => t === "listTotalAmount" ? "" : t

        }, {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 180,
            dataIndex: 'createTime',
            render: t => momentFormat(t, "YYYY-MM-DD")
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        if (code === "listTotalAmount") return;
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    const totalRow = {
        code: "listTotalAmount",
        totalTxt: "合计:",
        id: "",
        exchangeRate: "", goodsAmount: "", addAmount: "",
        typeNum: dataSource.reduce((con, next) => { con = con + +(next?.typeNum ?? 0); return con }, 0),
        contractAmount: dataSource.reduce((con, next) => { con = con + +(next?.contractAmount ?? 0); return con }, 0),
    }

    return (
        <>
            <Table
                rowKey={record => record.code}
                loading={loading}
                rowSelection={{
                    // //全部选中时  (存string[])
                    // renderCell(checked, record, index, node) {
                    //     if (record.code  ===  "listTotalAmount") {
                    //         return <></>;
                    //     }
                    //     return node;
                    // },
                    getCheckboxProps: (record) => {
                        let checkboxProps: any = {};
                        if (record.code === "listTotalAmount") {
                            checkboxProps.disabled = true;
                        }
                        return checkboxProps;
                    },
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
                        selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                            : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                    },
                    onSelect: (record) => onRow(record.code),
                    selectedRowKeys: selectedRowKeys
                }}
                columns={columns}
                dataSource={dataSource.length > 0 ? [...dataSource, totalRow] : []}
                // pagination={{
                //     ...pgCfg,
                //     position: ["bottomCenter"],
                //     showTotal: () => `共${pgCfg.total}条`,
                //     onChange: (pageNum, pageSize) => {
                //         loadData({ pageNum, pageSize })
                //     }
                // }}
                pagination={false}
                onRow={record => ({
                    onClick: () => onRow(record.code),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        setSelectedRowKeys([record.code]);
                    }
                })}
                scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
            />
            <div style={{
                margin: "5px",
                display: "flex",
                justifyContent: "center"
            }}>
                {dataSource.length > 0 ? <Pagination  {...{
                    ...pgCfg,
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }} /> : <></>}
            </div>
        </>
    )
}
